import { render, staticRenderFns } from "./ConfigScheduleViewSystemNotificationsDetails.vue?vue&type=template&id=033e076b&scoped=true&"
import script from "./ConfigScheduleViewSystemNotificationsDetails.vue?vue&type=script&lang=js&"
export * from "./ConfigScheduleViewSystemNotificationsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConfigScheduleViewSystemNotificationsDetails.vue?vue&type=style&index=0&id=033e076b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e076b",
  null
  
)

export default component.exports